import * as yup from 'yup';

import { Variants } from 'types';

import { emailRegExp } from './emailValidation';

export const getDeliveryDetailsSchema = (isGuestUser: boolean) =>
  yup.object({
    from: yup
      .string()
      .max(30, 'Max 30 characters allowed')
      .when('isForMe', {
        is: false,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired()
      }),
    to: yup
      .string()
      .max(30, 'Max 30 characters allowed')
      .when('isForMe', {
        is: false,
        then: (schema) => schema.required(),
        otherwise: (schema) => schema.notRequired()
      }),
    message: yup.string().max(100, 'Max 100 characters allowed').notRequired(),
    isForMe: yup.boolean(),
    variant: isGuestUser ? yup.string().notRequired() : yup.string().required(),
    email: yup.string().when('isForMe', {
      is: true,
      then: (s) => s.notRequired(),
      otherwise: (s) =>
        s.matches(emailRegExp, 'Email is not valid').when('variant', {
          is: (v: string) => v === Variants.SavedRecipientEmails,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.notRequired()
        })
    }),
    newEmail: !isGuestUser
      ? yup
          .string()
          .matches(emailRegExp, 'Email is not valid')
          .when('variant', {
            is: (v: string) => v === Variants.NewEmail,
            then: (schema) => schema.required(),
            otherwise: (schema) => schema.notRequired()
          })
      : yup.string().matches(emailRegExp, 'Email is not valid').notRequired(),
    saveForFutureUse: yup.boolean()
  });
